import React from 'react';

/**
 * Category
 */
class Category extends React.Component {

  render() {
    return (
      <div id="category">
        <div id="categoryinner">
          <div className="category_section">
            <h2 className="title_hero category_title">メニュー一覧</h2>
            <div className="category_group">
              <div className="category_unit machine">
                <h3>業界平均</h3>
                <ul>
                  <li>
                    <a href="/K002/index.html">
                      <span className="icon">
                        <img src="/img/btn_menu_category1_01.png" alt="" width={44} height={44} />
                      </span>
                      <span className="name">レート別で見る</span>
                    </a>
                  </li>
                  <li>
                    <a href="/K002/index.html?typeFlg=1">
                      <span className="icon">
                        <img src="/img/btn_menu_category1_02.png" alt="" width={44} height={44} />
                      </span>
                      <span className="name">タイプ別で見る</span>
                    </a>
                  </li>
                  <li>
                    <a href="/K003/index.html">
                      <span className="icon">
                        <img src="/img/btn_menu_category1_03.png" alt="" width={44} height={44} />
                      </span>
                      <span className="name">地区別で見る</span>
                    </a>
                  </li>
                  <li>
                    <a href="/K004/index.html">
                      <span className="icon">
                        <img src="/img/btn_menu_category1_04.png" alt="" width={44} height={44} />
                      </span>
                      <span className="name">損益分岐割数別で見る</span>
                    </a>
                  </li>
                  <li>
                    <a href="/K005/index.html">
                      <span className="icon">
                        <img src="/img/btn_menu_category1_05.png" alt="" width={44} height={44} />
                      </span>
                      <span className="name">ランク別で見る</span>
                    </a>
                  </li>
                  <li>
                    <a href="/K006/index.html">
                      <span className="icon">
                        <img src="/img/btn_menu_category1_06.png" alt="" width={44} height={44} />
                      </span>
                      <span className="name">設置台数別で見る</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="category_group">
              <div className="category_unit sales">
                <h3>機種平均</h3>
                <ul>
                  <li>
                    <a href="/K007/index.html">
                      <span className="icon">
                        <img src="/img/btn_menu_category2_01.png" alt="" width={44} height={44} />
                      </span>
                      <span className="name">パチンコ別で見る</span>
                    </a>
                  </li>
                  <li>
                    <a href="/K007/index.html?ps=1">
                      <span className="icon">
                        <img src="/img/btn_menu_category2_02.png" alt="" width={44} height={44} />
                      </span>
                      <span className="name">スロット別で見る</span>
                    </a>
                  </li>
                  <li>
                    <a href="/K008/index.html">
                      <span className="icon">
                        <img src="/img/btn_menu_category2_03.png" alt="" width={44} height={44} />
                      </span>
                      <span className="name">地区別で見る</span>
                    </a>
                  </li>
                  <li>
                    <a href="/K009/index.html">
                      <span className="icon">
                        <img src="/img/btn_menu_category2_04.png" alt="" width={44} height={44} />
                      </span>
                      <span className="name">損益分岐割数別で見る</span>
                    </a>
                  </li>
                  <li>
                    <a href="/K010/index.html">
                      <span className="icon">
                        <img src="/img/btn_menu_category2_05.png" alt="" width={44} height={44} />
                      </span>
                      <span className="name">ランク別で見る</span>
                    </a>
                  </li>
                  <li>
                    <a href="/K013/index.html">
                      <span className="icon">
                        <img src="/img/btn_menu_category2_06.png" alt="" width={44} height={44} />
                      </span>
                      <span className="name">段階設定別で見る</span>
                    </a>
                  </li>
                  <li>
                    <a href="/K011/index.html">
                      <span className="icon">
                        <img src="/img/btn_menu_category2_07.png" alt="" width={44} height={44} />
                      </span>
                      <span className="name">期間ごとに見る</span>
                    </a>
                  </li>
                  <li>
                    <a href="/K012/index.html">
                      <span className="icon">
                        <img src="/img/btn_menu_category2_08.png" alt="" width={44} height={44} />
                      </span>
                      <span className="name">導入週で見る</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Category;
